<template>
  <div class="ecm__modal-addcart">
    <el-dialog :visible.sync="isOpen" :show-close="false">
      <div class="ecm__modal-addcart__content">
        <p class="ecm__modal-addcart__content-text">Successfully added to cart</p>
        <p class="ecm__modal-addcart__content-title">"{{ titleBook }}"</p>
      </div>
      <div class="ecm__modal-addcart__footer">
        <button class="btn-cancel" @click="isOpen = false">Cancel</button>
        <button class="btn-cart" @click="hadleToCartPage">
          View Cart
          <i class="fas fa-shopping-cart">
        </i></button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Modal_Addcart',
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    ...mapGetters({
      titleBook: 'book/titleBook'
    })
  },
  methods: {
    hadleToCartPage () {
      this.$data.isOpen = false
      this.$router.push('/cart')
    },
    handleShowDialog () {
      this.$data.isOpen = true
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__modal-addcart {
  position: absolute;
  &::v-deep .el-dialog__wrapper {
    .el-dialog {
      width: 30%;
      border-radius: 7px;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        .ecm__modal-addcart__content {
          word-break: normal;
          .ecm__modal-addcart__content-text {
            text-align: center;
            font-size: 22px;
            font-weight: 500;
          }
          .ecm__modal-addcart__content-title {
            font-size: 15px;
            font-weight: 500;
            text-align: center;
            margin: 10px 0;
          }
        }
        .ecm__modal-addcart__footer {
          margin-top: 20px;
          display: flex;
          justify-content: center;
          button {
            cursor: pointer;
            font-size: 15px;
            padding: 5px 7px;
            font-weight: 600;
            border: none;
            outline: none;
            border-radius: 5px;
            background: var(--color-grey-background);
            &:first-child {
              margin-right: 20px;
            }
            &.btn-cart {
              background: var(--color-blue-background);
              color: white;
              i {
                margin-left: 5px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
